import appConstants from '../../../../../../../../appConstants';
import iconRenderer from '../../../../../../../common/iconRenderer';
import { GeoCodeRenderer } from '@dataGrid/components/cellRenderer';
import { MultiSelectFilter, StaticFilter } from '@dataGrid/components/columnFilters';
import CheckBoxRenderer from '../../CheckBoxRenderer';
import {
  CheckIfAllProIncluded,
  checkIfProIncluded,
  handleCheckboxToggle,
  handleCheckboxToggleForAll
} from '../utils';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static geoCodeValueGetter(params) {
    return params.data.isDelivery ? params.data.isGeoCoded : params.data.isShipperGeoCoded;
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.DistantShipmentValidationGrid,
      rowSelection: 'multiple',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true
      },
      columns: [
        {
          headerName: '',
          cellRenderer: CheckBoxRenderer,
          headerComponent: CheckBoxRenderer,
          valueGetter: (params) => checkIfProIncluded(params),
          cellRendererParams: (params) => ({
            onChange: (isChecked) => handleCheckboxToggle(params, isChecked)
          }),
          headerComponentParams: (params) => ({
            value: CheckIfAllProIncluded(params),
            onChange: (isChecked) => handleCheckboxToggleForAll(params, isChecked)
          }),
          headerClass: 'checkBoxHeader',
          cellClassRules: {
            'gridCell-centerAlign': true
          },
          pinned: 'left',
          lockPosition: true,
          lockPinned: true,
          isInvisibleInShowHide: true,
          minWidth: appConstants.columnWidth.W_64,
          maxWidth: appConstants.columnWidth.W_64
        },
        {
          headerName: 'Pro#',
          headerTooltip: 'Pro ID',
          minWidth: appConstants.columnWidth.PROID,
          headerClass: 'headerCellStyle',
          filter: MultiSelectFilter,
          filterParams: {
            filterType: appConstants.FILTER_TYPES.STRING
          },
          field: 'proId'
        },
        {
          headerName: 'Customer',
          headerTooltip: 'Customer Name',
          minWidth: appConstants.columnWidth.CUSTOMER_NAME,
          filter: MultiSelectFilter,
          headerClass: 'headerCellStyle',
          field: 'consigneeName'
        },
        {
          headerName: 'Geocoding',
          headerTooltip: 'Geocoding',
          valueGetter: GridConfig.geoCodeValueGetter,
          minWidth: appConstants.columnWidth.GEOCODING,
          cellClass: 'gridCell-left,Align',
          cellRenderer: GeoCodeRenderer,
          filter: StaticFilter,
          filterParams: {
            staticOptions: Object.values(appConstants.geoCode),
            renderIcon: iconRenderer
          }
        }
      ]
    };
  }
}
